import React from "react"
import {withFormik} from "formik";
import * as yup from "yup"
import {authCodeRegExp} from "../../services/regex";
import InnerAuthCodeForm from "../../components/FormTemplates/auth/InnerAuthCodeForm";
import {IAuthCodeData} from "../../contracts/data/auth";
import httpClient from "../../services/httpClient";
import {authApi} from "../../constans/apiUrls";
import {storeLoginToken, storeSupportUserCode} from "../../helpers/authHelper";


const authCodeFormValidationSchema = yup.object().shape({
    code: yup.string().required("کد تایید الزامی میباشد").length(5, "کد تایید 5 رقم میباشد").matches(authCodeRegExp, "باید عدد وارد کنید")
})

interface IAuthCodeFormProps{
    handleSection: any,
    handleAfterLoginUser: any,
    mobile: string,
}

const AuthCodeForm = withFormik<IAuthCodeFormProps, IAuthCodeData>({
    mapPropsToValues: props => ({
        code: '',
    }),
    mapPropsToStatus: props => ({
        mobile: props.mobile,
    }),
    validationSchema:(props: any) => authCodeFormValidationSchema,
    handleSubmit: async (values,{props, setFieldError, setSubmitting}) => {
        await httpClient().post(authApi.verify_code, {mobile: props.mobile, code: values.code})
            .then(response => {
                if(response.status === 200){
                    props?.handleAfterLoginUser(response?.data?.data?.token, response?.data?.data?.code)
                    setSubmitting(false)
                }
            })
            .catch(err => {
                setFieldError('code',err.response?.status === 400 || err.response?.status === 404 ? err?.response?.data?.message : "شماره موبایل نادرست میباشد")
            })
    }
})(InnerAuthCodeForm)

export default AuthCodeForm